// @flow
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import styled, { ThemeProvider } from 'styled-components'
import Helmet from 'react-helmet'
import colors from '../../styles/colors'
import media from '../../styles/media'
import { authenticate, unauthenticate } from '../../actions/session'
import { openWelcomeModal } from '../../actions/modals'
import Alert from '../Alert'
import ContactModal from '../../components/ContactModal'
import WelcomeModal from '../../components/WelcomeModal'
import RebateTermsModal from '../../components/RebateTermsModal'
import ConsultationModal from '../../components/ConsultationModal'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'

const AppContainer = styled.div`
  padding-top: 95px;

  ${media.mdUp} {
    padding-top: 50px;
  }
`

type Props = {
  children?: any,
  location: Object,
  authenticate: Function,
  unauthenticate: Function,
  openWelcomeModal: Function
}

class App extends Component {
  static childContextTypes = {
    location: PropTypes.object
  }

  getChildContext() {
    return {
      location: this.props.location
    }
  }

  componentDidMount() {
    this.attemptLogin()
    // Uncomment to display popup for first time site visitors
    // this.displayWelcomeModal();
  }

  attemptLogin = () => {
    const token = localStorage.getItem('token')

    if (token) {
      this.props.authenticate()
    } else {
      this.props.unauthenticate()
    }
  }

  displayWelcomeModal = () => {
    const hasDisplayed = localStorage.getItem('hasDisplayedWelcome')
    const onWelcomePage = this.props.location.pathname === '/welcome'

    if (!hasDisplayed && !onWelcomePage) {
      this.props.openWelcomeModal()
    }

    if (!hasDisplayed || onWelcomePage) {
      localStorage.setItem('hasDisplayedWelcome', 'true')
    }
  }

  props: Props

  render() {
    return (
      <ThemeProvider theme={colors}>
        <AppContainer>
          <Helmet
            titleTemplate={'Kief Realty | %s'}
            meta={[
              { charset: 'utf-8' },
              {
                name: 'viewport',
                content: 'width=device-width, initial-scale=1'
              },
              { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
              {
                name: 'description',
                content: 'Central Illinois Real Estate Services'
              }
            ]}
          />
          <Alert pathname={this.props.location.pathname} />
          <Navbar />
          {this.props.children}
          <Footer />
          <ContactModal />
          <WelcomeModal />
          <RebateTermsModal />
          <ConsultationModal />
        </AppContainer>
      </ThemeProvider>
    )
  }
}

export default connect(
  null,
  { authenticate, unauthenticate, openWelcomeModal }
)(App)



// WEBPACK FOOTER //
// ./src/containers/App/index.js